"use client";

import { useEffect, useRef } from "react";
import { useRouter } from "next/navigation";
import { userApiService } from "../services/api/userApiService";
import { cookieManager, CookieName } from "../utils/cookieManager";
import { appStorage } from "../utils/appStorage";
import { authManager } from "../utils/authManager";
import logger from "../utils/logger";

const DEVICE_CHECK_INTERVAL = 5 * 60 * 1000; // 5 minutes

export default function DeviceCheckProvider({ children }) {
  const router = useRouter();
  const intervalRef = useRef(null);

  useEffect(() => {
    const verifyDevice = async () => {
      const userEmail = cookieManager.getCookie(CookieName.UserEmail);
      const deviceId = cookieManager.getCookie(CookieName.DeviceId);
      const appId = appStorage.getAppId();

      if (!userEmail || !deviceId || !appId) return;

      try {
        const response = await userApiService.verifyDeviceV2({
          user_email: userEmail,
          app_id: appId,
          device_id: deviceId,
        });

        if (response.statusCode === 200 && response.data && !response.data.valid) {
          logger.log("Device verification failed:", response.data.reason);
          const currentApp = appStorage.getAppName() || "smartenglish";
          const savedEmail = userEmail;
          authManager.clearAllData();
          router.replace(`/login?app=${currentApp}&email=${encodeURIComponent(savedEmail)}`);
        }
      } catch (error) {
        logger.error("Device verification error:", error);
      }
    };

    // Initial check after 10 seconds (give app time to load)
    const initialTimeout = setTimeout(verifyDevice, 10 * 1000);

    // Periodic check every 5 minutes
    intervalRef.current = setInterval(verifyDevice, DEVICE_CHECK_INTERVAL);

    return () => {
      clearTimeout(initialTimeout);
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [router]);

  return children;
}
